import { render } from "./firststepGrooming.vue?vue&type=template&id=70ef03d7&scoped=true"
import script from "./firststepGrooming.vue?vue&type=script&lang=js"
export * from "./firststepGrooming.vue?vue&type=script&lang=js"

import "./firststepGrooming.vue?vue&type=style&index=0&id=70ef03d7&scoped=true&lang=css"

import exportComponent from "E:\\ph_ready_one\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70ef03d7"]])

export default __exports__